import axios from 'axios';
import { useState, useEffect } from 'react';
import { getColumnLength } from '../../helpers/utils';
import useConfirm from '../../../../components/common/useConfirm';
import lodash from 'lodash';

const workerType = {
  staff: 'staff',
  contractual: 'contractual',
  operator: 'operator',
};

const useGetData = (
  annual_date: string | null | undefined,
  created_date: string | null | undefined,
  employee_id: string | null | undefined
) => {
  const [moduleData, setModuleData] = useState<any>({
    list: Array.from({ length: 5 }, () => lodash.cloneDeep({})),
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSync, setIsSync] = useState(false);
  const [DialogSync, confirmSync] = useConfirm(
    'Sync New Parts',
    'Are you sure you want to Sync ? Make sure to save any changes before syncing!'
  );

  useEffect(() => {
    setIsLoading(true);
    const handleApi = async () => {
      try {
        const response = await axios.get(
          `/api/salaryRouteContractual/${created_date}/${employee_id}`
        );
        response.data.success && setModuleData(response.data.result);
      } catch (err: any) {
        setIsLoading(false);
        setError(err);
      }
    };

    handleApi();
  }, [isSync]);

  return {
    moduleData,
    setIsSync,
    isLoading,
    DialogSync,
    error,
  };
};

export default useGetData;
